/* istanbul ignore next */
export const getHost = () => typeof location !== 'undefined' && location.host || ''; // eslint-disable-line
